var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.833 8a.545.545 0 0 1-.165.369l-7.686 7.47a.576.576 0 0 1-.38.161.576.576 0 0 1-.379-.16l-.825-.802a.515.515 0 0 1-.165-.369c0-.128.066-.272.165-.368L9.881 8 3.398 1.7a.545.545 0 0 1-.165-.37c0-.128.066-.272.165-.368L4.223.16a.576.576 0 0 1 .38-.16c.131 0 .28.064.379.16l7.686 7.471c.1.096.165.24.165.369Z","fill":"#fff"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
